rdefine('app/products/components/ProductForm',['backbone','text!products/product.html','app/products/collections/Languages',
    'app/products/components/TabChoiceLanguage','app/products/components/ProductFormLang'],function(Backbone,template,Languages, TabChoiceLanguage,ProductFormLang) {

    var OptionView = Backbone.Ribs.View.extend({
        tagName:'option',
        bindings:{
            el:{
                html:'model.value',
                attr:{
                    value:'model.id',
                    selected:{
                        data:'model.id',
                    }
                }
            }
        },
        initialize:function(opts) {
            this.bindings.el.attr.selected.processor = function(a) {
                return this.collection.cform.get("roles",[]) && this.collection.cform.get("roles",[]).indexOf(a.toString()) !== -1;
            }.bind(this);
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'product-form',
        bindings: {
            el: {
                toggleByClass: {
                    data: 'model.active'
                }
            },
            '.language-list':{
                collection:{
                    col:'languages',
                    view:TabChoiceLanguage
                }
            },
            '.language-tabs':{
                collection:{
                    col:'languages',
                    view:function(options){

                        return new ProductFormLang(options);
                    },
                    data:{
                        parent:null
                    }
                }
            },
            'input[name=published_at]':{
                value:{
                    data:'cform.published_at',
                    events:'change dp.change'
                }
            },
            'input[name=published]':{
                checked:'cform.published'
            },
            'input[name=is_new]':{
                checked:'cform.is_new'
            },
            'select[name=new_expire]':{
                value:{
                    data:'cform.new_expire',
                    events:'change dp.change changed.bs.select'
                }
            },
            ".save-variant":{
                disabled:{
                    data:'dmodel.dirty',
                    processor:function(d){
                        return !d;
                    }
                }
            },
            "select[name='roles\\[\\]']":{
                value:'cform.roles',
                collection:{
                    col:'rolesCollection',
                    view:function(options) {
                        return new OptionView(options);
                    }
                }
            }
        },
        languages:null,
        parent:null,
        state:null,
        dmodel:null,
        events:{
            "click .cancel-variant": "cancel",
            "click .save-variant": "save"
        },
        initialize:function(options) {
            this.parent = options.parent;
            this.dmodel = this.parent.model;
            this.bindings['.language-tabs'].collection.data.parent = this;
            this.bindings['.language-tabs'].collection.data.properties = options.properties;
            this.bindings['.language-tabs'].collection.data.ndx = this.model.collection.indexOf(this.model);
            console.log('set',this.model.get('cform'));
            this.cform = new Backbone.Ribs.Model(this.model.get('cform'));
            //this.model.set('cform',this.cform.attributes);
            this.model.$el = this.$el;

            this.languages = new Languages(options.languages);
            this.languages.ndx = this.model.collection.indexOf(this.model);

            this.deflang = this.languages.findWhere({'default':1});
            this.deflang.set("active",true);

            this.rolesCollection = new Backbone.Ribs.Collection(window.RolesObject,{model:Backbone.Ribs.Model});
            this.rolesCollection.cform = this.cform;
            $.getJSON("",function (resp) {
            //    this.rolesCollection.reset(resp.items);
             //   this.$el.find("select").selectpicker('refresh');
            }.bind(this));

            this.$el.html(Template7.compile(template)({cindex:this.model.collection.indexOf(this.model),currentlang:window.currentlang,expires:window.expirelist}));
            //place images by images
            var images = this.cform.get("images",[]);
            _.map(images, function(image) {
                this.$el.find(".images-place").append($('<img/>').attr("src",image.src).attr('data-id',image.id).attr("data-meta",image.meta));
            }.bind(this));
            var mdas = this.cform.get("medias","");
            if(mdas && mdas.length) {
                this.$el.find(".medias-place img").attr("src",mdas);
            }else{
                this.$el.find(".medias-place img").remove();
            }
            this.on("update-lang",this.updateLang.bind(this));
            this.cform.on("change",function(){

                this.model.set("cform",this.cform.attributes);
                this.model.collection.trigger("triggchange");
                this.parent.model.set("dirty",true);
            }.bind(this));

            setTimeout(function(){
            this.$el.find("select").selectpicker();

            this.$el.find(".image-choicer")[0].multi = new MultiImages(this.$el.find(".image-choicer")[0],"images_"+this.model.collection.indexOf(this.model));
            this.$el.find(".image-choicer").addClass("multiimages");
            }.bind(this),0);
            this.$el.find(".save-variant").text(this.cform.get("id")?LANGUAGE['basic.apply']:LANGUAGE['basic.apply']);
        },
        updateLang:function(lang,form) {
            this.cform.set("lang."+lang,form.attributes);
            this.cform.trigger("change");
        },
        cancel:function() {
            return this.parent.cancel();
        },
        save:function() {
            return this.parent.save();
        }
    });
});